import React, { useState, useEffect, useRef } from 'react';
import { stockInProduct, validateProductBarcode, getReturnStockBarcodeDetails } from '../../../services/ProductService';
import { searchRack, searchSource } from '../../../services/RackService';
import { searchMaterial } from '../../../services/ReportService';
import { Modal, Spinner, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useDispatch, connect } from 'react-redux';
import { createSource } from '../../../services/OtherService';
import { toggleStockinModal, setScanBarcode, updateStockKey } from '../../../store/actions/AuthActions';
import CreatableSelect from 'react-select/creatable'
import Select from 'react-select'
import HelpTooltip from '../../constant/HelpToolTip';
import ReservationStockIn from './ReservationStockIn';

function StockInBtn({ modalOpen, scanBarcode }) {
  const emptyStock = {
    barcode_no: '',
    is_valid_barcode: false,
    quantity: '',
    product: null,
    rack: null,
    source: null,
    showRmConf: false,
    isRackDisable: false,
    isMultiStock: true
  }
  const STOCKIN_TYPE_CHOICE = ["RESERVATION", "NEW MATERIAL", "RETURN MATERIAL", "BORROWING MATERIAL", "RECEIVE LENT MATERIAL"]
  const dispatch = useDispatch()
  const reservationFormRef = useRef(null);


  const [isSubmitLoading, setIsSubmitLoading] = useState(false)
  const [stock, setStock] = useState([emptyStock])

  const [exitModalOpen, setExitModalOpen] = useState(false)

  const [sourceModalOpen, setSourceModalOpen] = useState(false)
  const [newSourceIndexName, setNewSourceIndexName] = useState({ index: 0, sourceName: "" }); // for create source to add source data

  // source
  const [sourceOption, setSourceOption] = useState([])
  const [isSourceLoading, setIsSourceLoading] = useState(false)

  // material
  const [productOption, setProductOption] = useState([])
  const [isProductLoading, setIsProductLoading] = useState(false)
  // rack
  const [optionRack, SetOptionRack] = useState([])
  const [isRackLoading, setIsRackLoading] = useState(false)
  const [stockinType, setStockinType] = useState(STOCKIN_TYPE_CHOICE[0])

  useEffect(() => {
    const handleDefaultBarcodeScan = async () => {
      try {
        const newStock = { ...emptyStock, barcode_no: scanBarcode, is_valid_barcode: true }
        setStock([newStock]);
      } catch (error) {
        toast.error(error.response.data.message)
      } finally {
        dispatch(setScanBarcode(null))
      }
    };

    if (scanBarcode && modalOpen) {
      handleDefaultBarcodeScan()
      fetchMaterialOptions()
      fetchRackOptions()
      fetchSourceOptions()
    }
  }, [scanBarcode, modalOpen])

  const toggleExitModal = () => {
    setExitModalOpen(!exitModalOpen)
  }

  const toggleModal = () => {
    if (modalOpen) {
      setStock([emptyStock])
      setSourceOption([])
      setProductOption([])
      SetOptionRack([])
      setExitModalOpen(false)
      setStockinType(STOCKIN_TYPE_CHOICE[0])

    } else {
      fetchMaterialOptions()
      fetchRackOptions()
      fetchSourceOptions(stockinType)
    }
    dispatch(toggleStockinModal());
  }

  const handleInputChange = (value, index) => {
    let newStock = [...stock]
    const elem = document.getElementById(`barcode_no-${index}`)
    newStock[index] = { ...newStock[index], barcode_no: value, is_valid_barcode: false, isRackDisable: false }
    elem?.classList.add('is-invalid')
    setStock([...newStock]);
  };

  const handleQuantityChange = (value, index) => {
    const elem = document.getElementById(`quantity-${index}`)
    if (stockinType === "RETURN MATERIAL") {
      let newStock = [...stock]
      const min = 1; // Set your minimum value here
      const max = newStock[index]?.net_quantity || newStock[index]?.quantity; // Set your maximum value here
      // Check if the input is within the specified range
      if (value === '' || (value >= min && value <= max)) {
        newStock[index] = { ...newStock[index], quantity: value }
        setStock([...newStock]);
        elem?.classList.remove('is-invalid')
      } else {
        elem?.classList.add('is-invalid')
      }
    } else {
      if (value === '' || Number(value) > 0) {
        let newStock = [...stock]
        newStock[index] = { ...newStock[index], quantity: Number(value) }
        setStock([...newStock]);
        elem?.classList.remove('is-invalid')
      } else {
        elem?.classList.add('is-invalid')
      }
    }
  };


  const hasDuplicatesStock = () => {
    const idSet = new Set();
    for (const s of stock) {
      if (idSet.has(s.barcode_no)) {
        return true; // Found a duplicate id
      }
      idSet.add(s.barcode_no);
    }
    return false; // No duplicates found
  };

  const handleKeyPress = async (e, index) => {
    if (e.key === 'Enter' && e.target.value.length > 0) {
      if (hasDuplicatesStock()) {
        toast.error("Barcode already exists in stock IN list")
      } else {
        const elem = document.getElementById(`barcode_no-${index}`)
        try {
          const product_id = stock[index].product?.value
          const resp = await validateProductBarcode(e.target.value, product_id);
          const existingRack = resp.data?.existing_rack
          let newStock = [...stock]
          if (existingRack) {
            newStock[index] = { ...newStock[index], is_valid_barcode: true, isRackDisable: true, rack: existingRack }
          } else {
            newStock[index] = { ...newStock[index], is_valid_barcode: true }
          }
          setStock([...newStock]);
          elem?.classList.remove('is-invalid')
        } catch (error) {
          elem?.classList.add('is-invalid')
          toast.error(error.response.data.message)
        }
      }
    }
  };

  const validateStocks = () => {
    return stock.map((item, index) => {
      const validList = ['barcode_no', 'quantity', 'rack', 'product', 'source']
      return Object.entries(item).map(([key, value]) => {
        if (validList.includes(key)) {
          if (value === null || value.length === 0) {
            const elem = document.getElementById(`${key}-${index}`)
            elem.classList.add('is-invalid')
            elem.focus()
            return false
          }
          return true
        } else if (key === 'is_valid_barcode' && !value) {
          const elem = document.getElementById(`barcode_no-${index}`)
          elem.classList.add('is-invalid')
          elem.focus()
          return false
        } else if (key === 'expired_date' && !value) {
          const elem = document.getElementById(`expired_date-${index}`)
          elem.classList.add('is-invalid')
          elem.focus()
          return false
        }
        return true
      }).every(val => val === true)

    })
  }

  const addStock = () => {
    if (validateStocks().every(value => value === true)) {
      setStock(stock.concat(emptyStock))
    }
  }

  const removeStock = (index) => {
    const newStock = [...stock]
    newStock.splice(index, 1)
    setStock([...newStock])
  }

  const removeConfirm = (index, toggleVal) => {
    const newStock = [...stock]
    newStock[index] = { ...newStock[index], showRmConf: toggleVal }
    setStock([...newStock])
  }

  const onSubmitStockIN = () => {
    if (!isSubmitLoading) {
      if (stockinType === "RESERVATION") {
        reservationFormRef.current.submit();
        return;
      }
      if (validateStocks().every(value => value === true)) {
        const data = stock.filter(item => item.quantity > 0 && item.is_valid_barcode).map(st => {
          return {
            barcode_no: st.barcode_no,
            quantity: Number(st.quantity),
            product_id: st.product.value,
            rack_id: st.rack.value,
            source: st.source.value,
            ...((st.product.perishable_product && stockinType !== "RETURN MATERIAL") && { expired_date: st.expired_date || "" })
          }
        })
        setIsSubmitLoading(true)
        stockInProduct({ stock_list: data, stockin_type: stockinType }).then((response) => {
          toast.success(response.data.message)
          toggleModal()
          dispatch(updateStockKey())
        }).catch((error) => {
          toast.error(error.response?.data?.message)
        }).finally(() => {
          setIsSubmitLoading(false)
        });
      }
    }
  }

  const LoadingIndicator = () => {
    return (
      <Spinner color='primary' size={'sm'} delay={0} />
    )
  }

  const handleStockinType = (e) => {
    const { value } = e.target
    setStockinType(value)
    fetchSourceOptions(value)
    setStock([emptyStock])

  }

  const handleSourceChange = (data, index) => {
    try {
      let newStock = [...stock]
      newStock[index] = { ...newStock[index], source: { value: data.value, label: data.label } }
      setStock([...newStock]);
      document.getElementById(`source-${index}`)?.classList.remove('is-invalid')
    } catch (error) {
      console.log(error.response.data.message)
    }
  }

  const handleProudctChange = (data, index) => {
    try {
      let newStock = [...stock]
      if (data.perishable_product) {
        newStock[index] = {
          ...newStock[index],
          product: { ...data },
          isMultiStock: data.is_multi_unit,
          quantity: data.is_multi_unit ? '' : 1,
          expired_date: ""
        }
      } else {
        newStock[index] = {
          ...newStock[index],
          product: { ...data },
          isMultiStock: data.is_multi_unit,
          quantity: data.is_multi_unit ? '' : 1,
        }
        if (newStock[index].hasOwnProperty('expired_date')) {
          delete newStock[index].expired_date; // Remove expired_date key
        }
      }
      setStock([...newStock]);
      document.getElementById(`product-${index}`)?.classList.remove('is-invalid')
    } catch (error) {
      console.log(error)
    }
  }

  const handleRackChange = (data, index) => {
    try {
      let newStock = [...stock]
      newStock[index] = { ...newStock[index], rack: { value: data.value, label: data.label } }
      setStock([...newStock]);
      document.getElementById(`rack-${index}`)?.classList.remove('is-invalid')
    } catch (error) {
      console.log(error.response.data.message)
    }
  }

  const handleExpiredDateChange = (value, index) => {
    const today = new Date();
    today.setDate(today.getDate() + 1); // Add 1 day to today
    const minDate = today.toISOString().split('T')[0];
    try {
      let newStock = [...stock]
      newStock[index] = { ...newStock[index], expired_date: value }
      setStock([...newStock]);
      document.getElementById(`expired_date-${index}`)?.classList.remove('is-invalid')
    } catch (error) {
      console.log(error.response.data.message)
    }

    if (value < minDate) {
      document.getElementById(`expired_date-${index}`)?.classList.add('is-invalid')
      return;
    }


  };

  const handleReturnBarcode = async (e, index) => {
    if (e.key === 'Enter' && e.target.value.length > 0) {
      if (hasDuplicatesStock()) {
        toast.error("Barcode already exists in stock OUT list")
      } else {
        try {
          const response = await getReturnStockBarcodeDetails(e.target.value);
          const { data } = response.data
          let newStock = [...stock]
          newStock[index] = {
            ...newStock[index],
            quantity: data.quantity,
            net_quantity: data.quantity,
            product: data.product,
            rack: data.rack,
            is_valid_barcode: true,
            isMultiStock: data.product.is_multi_unit,
          }
          setStock([...newStock]);
          document.getElementById(`barcode_no-${index}`)?.classList.remove('is-invalid')
        } catch (error) {
          toast.error(error.response.data.message)
        }
      }
    }
  };

  async function fetchMaterialOptions() {
    try {
      setIsProductLoading(true)
      const resp = await searchMaterial()
      setProductOption(resp.data.data)
    }
    catch (error) {
      console.log("ERROR => ", error)
    } finally {
      setIsProductLoading(false)
    }
  };

  async function fetchRackOptions() {
    try {
      setIsRackLoading(true)
      const resp = await searchRack()
      SetOptionRack(resp.data.data)
    }
    catch (error) {
      console.log("ERROR => ", error)
    } finally {
      setIsRackLoading(false)
    }
  };

  async function fetchSourceOptions(stokcintype) {
    try {
      setIsSourceLoading(true)
      const resp = await searchSource({ stock_type: stokcintype })
      setSourceOption(resp.data.data)
    }
    catch (error) {
      console.log("ERROR => ", error)
    } finally {
      setIsSourceLoading(false)
    }
  };


  const toggleSourceModal = () => {
    if (sourceModalOpen) {
      setNewSourceIndexName({ index: 0, sourceName: "" })
    }
    setSourceModalOpen(!sourceModalOpen)
  }

  const handleBorrowSourceChange = (data, index) => {
    try {
      if (data.__isNew__) {
        setNewSourceIndexName({ sourceName: data.value, index })
        toggleSourceModal()
      } else {
        const newStock = [...stock]
        newStock[index] = { ...newStock[index], source: { value: data.value, label: data.label } }
        setStock([...newStock]);
        document.getElementById(`employee-${index}`)?.classList.remove('is-invalid')
      }
    } catch (error) {
      console.log(error.response.data.message)
    }
  }

  const handleSubmitSource = async (e) => {
    e.preventDefault()
    const { index, sourceName } = newSourceIndexName
    createSource({ name: sourceName, central_store: false }).then((resp) => {
      const { data, message } = resp.data
      const newOption = { value: data.value, label: data.label }
      setSourceOption([...sourceOption, newOption])
      let newStock = [...stock]
      newStock[index] = { ...newStock[index], source: newOption }
      setStock([...newStock]);
      toast.success(message)
      toggleSourceModal()
    }).catch((error) => {
      console.log("error", error)
      toast.error(error.response.data.message)
    });
  }


  return (
    <>
      <button className="btn btn-success mx-2" onClick={toggleModal}>Stock IN <i className="fa-solid fa-cart-arrow-down ms-2"></i> </button>
      {/* stock out modal */}

      <Modal className="modal fade" id="exampleModal3"
        show={modalOpen}
        onHide={toggleModal}
        fullscreen={true}
        backdrop="static"
        keyboard={false} >
        <div className="modal-content">
          <div className="modal-header bg-success">
            <h3 className="modal-title">Stock IN</h3>
            <button type="button" className="btn btn-secondary light btn-sm" onClick={toggleModal}>
              <i className="fa-solid  fa-lg fa-xmark"></i>
            </button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label className='form-label fw-bold me-3'>Stock In Type:</label>
              {STOCKIN_TYPE_CHOICE.map(item => (
                <div className="form-check custom-checkbox mb-2 form-check-inline" key={item}>
                  <input type="radio"
                    className="form-check-input"
                    checked={stockinType === item}
                    id={item}
                    name="stockinType"
                    value={item}
                    onChange={handleStockinType} />
                  <label className="form-check-label" htmlFor={item}>{item}</label>
                </div>
              ))}
            </div>
            {stockinType === "RESERVATION" ? <ReservationStockIn
              ref={reservationFormRef}
              toggleModal={toggleModal}
              setIsSubmitLoading={setIsSubmitLoading}
            /> : (
              <div className='table-responsive active-projects' style={{ minHeight: '80vh' }}>
                <div id="employee-tbl_wrapper" className="dataTables_wrapper active-projects no-footer">
                  {stockinType === STOCKIN_TYPE_CHOICE[2] ? (
                    <div className='table-responsive active-projects' style={{ minHeight: '80vh' }}>
                      <div id="employee-tbl_wrapper" className="dataTables_wrapper active-projects no-footer">
                        <table id="empoloyees-tblwrapper" className="table table-striped ItemsCheckboxSec dataTable no-footer mb-0">
                          <thead>
                            <tr>
                              <th>Barcode</th>
                              <th>Quantity</th>
                              <th>Material</th>
                              <th>Rack</th>
                              <th>Source</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {stock.map((item, index) => (
                              <tr key={index}>
                                <td>
                                  <input type="text"
                                    id={`barcode_no-${index}`}
                                    style={{ width: '10rem' }}
                                    autoFocus={item.barcode_no.length === 0}
                                    value={item.barcode_no}
                                    onChange={(e) => { handleInputChange(e.target.value, index) }}
                                    onKeyPress={(e) => { handleReturnBarcode(e, index) }}
                                    className="form-control" placeholder="Barcode" />
                                </td>
                                {item.is_valid_barcode ? (<>
                                  <td>
                                    <div className='input-group' style={{ minWidth: '8rem', maxWidth: '10rem' }}>
                                      <input type="number"
                                        min={1}
                                        max={item?.net_quantity || item?.quantity}
                                        autoFocus={true}
                                        onChange={(e) => { handleQuantityChange(e.target.value, index) }}
                                        value={item.quantity}
                                        className="form-control" id={`quantity-${index}`} placeholder="Quantity" />
                                      <span className="input-group-text">{item?.net_quantity}</span>
                                    </div>
                                  </td>

                                  <td><span className='text-primary'>{item.product?.label || ""}</span></td>

                                  <td>
                                    <Select
                                      value={item.rack}
                                      onChange={(data) => handleRackChange(data, index)}
                                      placeholder={"Select Rack"}
                                      isClearable={false}
                                      isLoading={isRackLoading}
                                      options={optionRack}
                                      id={`rack-${index}`}
                                      className='react-select'
                                      classNamePrefix='select'
                                      styles={
                                        {
                                          container: (provided) => ({
                                            ...provided,
                                            width: '12rem', // Set the width of the select container
                                          }),
                                        }
                                      }
                                    />
                                  </td>
                                  <td>
                                    <Select
                                      isClearable={false}
                                      id={`source-${index}`}
                                      value={item.source}
                                      className='react-select'
                                      classNamePrefix='select'
                                      placeholder="Search Source"
                                      options={sourceOption}
                                      isLoading={isSourceLoading}
                                      onChange={(data) => { handleSourceChange(data, index) }}
                                      components={{ LoadingIndicator }}
                                      styles={
                                        {
                                          container: (provided) => ({
                                            ...provided,
                                            width: '15rem', // Set the width of the select container
                                          }),
                                        }
                                      }
                                    />
                                  </td>
                                </>) : (<>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                </>)}

                                <td>

                                  {item.is_valid_barcode && (stock.length === index + 1) && !item.showRmConf ? (
                                    <button className='btn btn-sm me-2 btn-outline-success rounded' onClick={addStock}><i className="fa-solid fa-lg fa-plus"></i></button>
                                  ) : null}
                                  {stock.length > 1 ? item.showRmConf ? (
                                    <div className="d-flex align-items-center flex-column bg-light p-2 rounded">
                                      <h6>Confirm Remove</h6>
                                      <div className='d-flex justify-content-around align-items-center'>
                                        <span className='c-pointer badge badge-outline-success badge-sm'
                                          onClick={() => removeStock(index)}>
                                          <i class="fa-solid fa-check"></i>
                                        </span>
                                        <span className='c-pointer badge badge-outline-danger badge-sm ms-3'
                                          onClick={() => removeConfirm(index, false)}>
                                          <i class="fa-solid fa-xmark"></i>
                                        </span>
                                      </div>
                                    </div>
                                  ) : (
                                    <button className='btn btn-sm btn-outline-danger rounded'
                                      onClick={() => {
                                        item.is_valid_barcode > 0 ? removeConfirm(index, true) : removeStock(index)
                                      }}>
                                      <i className="fa-solid fa-trash"></i>
                                    </button>
                                  ) : null}
                                </td>

                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    <table id="empoloyees-tblwrapper" className="table table-striped ItemsCheckboxSec dataTable no-footer mb-0">
                      <thead>
                        <tr>
                          <th>Material</th>
                          <th>Quantity</th>
                          <th>Rack</th>
                          <th>Source</th>
                          <th>Barcode</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {stock.map((item, index) => (
                          <tr key={index}>
                            <td>
                              <div className='d-flex align-items-center gap-1'>
                                <Select
                                  value={item.product}
                                  onChange={(data) => handleProudctChange(data, index)}
                                  placeholder={"Select Material"}
                                  isClearable={false}
                                  isLoading={isProductLoading}
                                  options={productOption}
                                  id={`product-${index}`}
                                  className='react-select'
                                  classNamePrefix='select'
                                  styles={
                                    {
                                      container: (provided) => ({
                                        ...provided,
                                        width: '20rem', // Set the width of the select container
                                      }),
                                    }
                                  }
                                />
                                {item.product?.label?.length > 25 && <HelpTooltip text={item.product?.label} />}
                              </div>
                            </td>
                            <td>
                              <div className='d-flex align-items-center'>
                                <input type="number"
                                  min={1}
                                  style={{ minWidth: '5rem', maxWidth: '8rem' }}
                                  onChange={(e) => { handleQuantityChange(e.target.value, index) }}
                                  value={item.quantity}
                                  disabled={item.product === null || !item.isMultiStock}
                                  className="form-control" id={`quantity-${index}`} placeholder="Quantity" />
                                {item.product?.perishable_product && (
                                  <div className='ms-3'>
                                    <label style={{
                                      display: 'block',
                                      fontSize: '0.8rem',
                                      marginBottom: '0.2rem'
                                    }}>Expired Date</label>

                                    <input
                                      type="date"
                                      min={new Date(Date.now() + 86400000).toISOString().split('T')[0]} // +1 day
                                      onChange={(e) => handleExpiredDateChange(e.target.value, index)}
                                      value={item?.expired_date || ""}
                                      className="form-control"
                                      style={{ width: '8rem', height: '1.5rem' }}
                                      id={`expired_date-${index}`}
                                    />
                                  </div>
                                )}
                              </div>
                            </td>
                            <td>
                              <Select
                                value={item.rack}
                                onChange={(data) => handleRackChange(data, index)}
                                placeholder={"Select Rack"}
                                isClearable={false}
                                isLoading={isRackLoading}
                                isDisabled={item.isRackDisable}
                                options={optionRack}
                                id={`rack-${index}`}
                                className='react-select'
                                classNamePrefix='select'
                                styles={
                                  {
                                    container: (provided) => ({
                                      ...provided,
                                      width: '12rem', // Set the width of the select container
                                    }),
                                  }
                                }
                              />
                            </td>
                            <td>
                              {"BORROWING MATERIAL" === stockinType ? (
                                <CreatableSelect
                                  isClearable={false}
                                  id={`source-${index}`}
                                  value={item.source}
                                  className='react-select'
                                  classNamePrefix='select'
                                  placeholder="Search Source"
                                  options={sourceOption}
                                  isLoading={isSourceLoading}
                                  onChange={(data) => { handleBorrowSourceChange(data, index) }}
                                  components={{ LoadingIndicator }}
                                  styles={
                                    {
                                      container: (provided) => ({
                                        ...provided,
                                        width: '15rem', // Set the width of the select container
                                      }),
                                    }
                                  }
                                />
                              ) : (
                                <Select
                                  isClearable={false}
                                  id={`source-${index}`}
                                  value={item.source}
                                  className='react-select'
                                  classNamePrefix='select'
                                  placeholder="Search Source"
                                  options={sourceOption}
                                  isLoading={isSourceLoading}
                                  onChange={(data) => { handleSourceChange(data, index) }}
                                  components={{ LoadingIndicator }}
                                  styles={
                                    {
                                      container: (provided) => ({
                                        ...provided,
                                        width: '15rem', // Set the width of the select container
                                      }),
                                    }
                                  }
                                />
                              )}
                            </td>
                            <td>
                              <input type="text"
                                id={`barcode_no-${index}`}
                                style={{ width: '10rem' }}
                                value={item.barcode_no}
                                disabled={item.product === null}
                                onChange={(e) => { handleInputChange(e.target.value, index) }}
                                onKeyPress={(e) => { handleKeyPress(e, index) }}
                                className="form-control"
                                placeholder={item.product === null ? "Select Product First" : "Enter Barcode"} />
                            </td>
                            <td>
                              {item.is_valid_barcode && (stock.length === index + 1) && !item.showRmConf ? (
                                <button className='btn btn-sm me-2 btn-outline-success rounded' onClick={addStock}><i className="fa-solid fa-lg fa-plus"></i></button>
                              ) : null}
                              {stock.length > 1 ? item.showRmConf ? (
                                <div className="d-flex align-items-center flex-column bg-light p-2 rounded">
                                  <h6>Confirm Remove</h6>
                                  <div className='d-flex justify-content-around align-items-center'>
                                    <span className='c-pointer badge badge-outline-success badge-sm'
                                      onClick={() => removeStock(index)}>
                                      <i class="fa-solid fa-check"></i>
                                    </span>
                                    <span className='c-pointer badge badge-outline-danger badge-sm ms-3'
                                      onClick={() => removeConfirm(index, false)}>
                                      <i class="fa-solid fa-xmark"></i>
                                    </span>
                                  </div>
                                </div>
                              ) : (
                                <button className='btn btn-sm btn-outline-danger rounded'
                                  onClick={() => {
                                    item.barcode_no.length > 0 ? removeConfirm(index, true) : removeStock(index)
                                  }}>
                                  <i className="fa-solid fa-trash"></i>
                                </button>
                              ) : null}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div >
            )}
          </div >
          <div className="modal-footer">
            <button type="submit" className="btn btn-primary btn-sm" disabled={isSubmitLoading} onClick={onSubmitStockIN}>
              {isSubmitLoading ? (<>
                <LoadingIndicator /> Stock IN
              </>) : "Stock IN"}
            </button>
            <button type="button" className="btn btn-danger light btn-sm" disabled={isSubmitLoading} onClick={toggleModal}>Close</button>
          </div>
        </div >
      </Modal >

      {/* create emplppyee modal */}
      < Modal className="modal  modal-sm fade" id="exampleModal3"
        show={exitModalOpen}
        onHide={toggleExitModal}
        backdrop="static"
        keyboard={false} >
        <div className="modal-content">
          <div className="modal-header ">
            <h3 className="modal-title">Exit Confirm</h3>
          </div>
          <div className="modal-body">
            <p>You have unsaved changes. Are you sure you want to leave?</p>
            <div>
              <button type="submit" className="btn btn-primary btn-sm me-1" onClick={() => toggleExitModal()} >
                Keep
              </button>
              <button type="button" onClick={() => toggleModal()} className="btn btn-danger  btn-sm light mx-1">Discard</button>
            </div>
          </div>
        </div>
      </Modal >

      {/* create source modal */}
      <Modal className="modal modal-sm fade" id="exampleModal1" show={sourceModalOpen} onHide={toggleSourceModal}>
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel1">Create New Source</h1>
            <button type="button" className="btn-close" onClick={toggleSourceModal}></button>
          </div>
          <div className="modal-body">
            <Form onSubmit={(e) => { handleSubmitSource(e) }} method='POST'>
              <div className="row">
                <div className="col-xl-12">
                  <label className="form-label">Source Name<span className="text-danger">*</span></label>
                  <input type="text"
                    className="form-control mb-3"
                    placeholder="Enter Source Name" required
                    value={newSourceIndexName.sourceName} onChange={(e) => setNewSourceIndexName({ ...newSourceIndexName, sourceName: e.target.value })} />
                </div>
              </div>
              <button type="submit" className="btn btn-block btn-sm btn-primary mt-3 float-end">Submit</button>
            </Form>
          </div>
        </div>
      </Modal>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    modalOpen: state.auth.stockinModal,
    scanBarcode: state.auth.scanBarcode
  };
};

export default connect(mapStateToProps)(StockInBtn);